import { api } from 'src/api';
import { cast, getRoot, types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const getCredentialsAsync = createAsync(() => {
  return async function getCredentials(options) {
    const resp = await api.Credentials.getCredentials(options);
    return resp;
  };
});
const postCredentialsAsync = createAsync(body => {
  return async function postCredentials(options) {
    const resp = await api.Credentials.postCredentials(body, options);
    return resp;
  };
});
const getCredentialsUsersAsync = createAsync(body => {
  return async function getCredentialsUsers(options) {
    const resp = await api.Credentials.getCredentialsUsers(body, options);
    return resp;
  };
});
const getCredentialsPropertiesAsync = createAsync(body => {
  return async function getCredentialsProperties(options) {
    const resp = await api.Credentials.getCredentialsProperties(body, options);
    return resp;
  };
});
const patchCredentialsAsync = createAsync(body => {
  return async function patchCredentials(options) {
    const resp = await api.Credentials.patchCredentials(body, options);
    return resp;
  };
});
const getGlAccountsAsync = createAsync(body => {
  return async function getGlAccounts(options) {
    const resp = await api.Credentials.getGlAccounts(body, options);
    return resp;
  };
});
const patchCredentialsPropertiesAsync = createAsync(body => {
  return async function patchCredentialsProperties(options) {
    const resp = await api.Credentials.patchCredentialsProperties(body, options);
    return resp;
  };
});
const deleteCredentialAsync = createAsync(body => {
  return async function deleteCredential(options) {
    const resp = await api.Credentials.deleteCredential(body, options);
    return resp;
  };
});
const getGLAccountsAsync = createAsync(body => {
  return async function getGLAccounts(options) {
    var _getRoot$homeDashboar;
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const resp = await api.Credentials.getGLAccounts(options);
    this.setGlAccounts(resp.response);
    if (applyToHomeDashboard && !!((_getRoot$homeDashboar = getRoot(this).homeDashboardStore.getCurrentCompany) !== null && _getRoot$homeDashboar !== void 0 && _getRoot$homeDashboar.selectedPropertyDetails())) {
      var _getRoot$homeDashboar2;
      (_getRoot$homeDashboar2 = getRoot(this).homeDashboardStore.getCurrentCompany) === null || _getRoot$homeDashboar2 === void 0 || _getRoot$homeDashboar2.selectedPropertyDetails().details.glCodeSetup.setGlAccounts(resp.response);
    }
    return resp;
  };
});
const getAppfolioPropertiesAsync = createAsync(() => {
  return async function getAppfolioProperties(options) {
    const resp = await api.Credentials.getAppfolioProperties(options);
    return resp;
  };
});
const patchAppfolioPropertiesAsync = createAsync(body => {
  return async function patchAppfolioProperties(options) {
    const resp = await api.Credentials.patchAppfolioProperties(body, options);
    return resp;
  };
});
const getPropertiesByIdAsync = createAsync(body => {
  return async function getPropertiesById(options) {
    const resp = await api.Credentials.getPropertiesById(body, options);
    return resp;
  };
});
const getPendingBatchesAsync = createAsync(body => {
  return async function getPendingBatches(options) {
    const resp = await api.Credentials.getPendingBatches(body, options);
    return resp;
  };
});
const getPendingBatchesByIdAsync = createAsync(body => {
  return async function getPendingBatchesById(options) {
    const resp = await api.Credentials.getPendingBatchesById(body, options);
    return resp;
  };
});
const GLAccount = types.model({
  externalId: types.maybeNull(types.string),
  accountName: types.maybeNull(types.string),
  accountType: types.maybeNull(types.string),
  lastUpdatedAt: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  number: types.maybeNull(types.string),
  type: types.maybeNull(types.string)
});
const UtilityGlSettings = types.model({
  utilityId: types.string,
  propertyUtilityLivableId: types.maybeNull(types.string),
  glAccountExternalId: types.string
});
const CredentialsStore = types.model('AllocationsStore', {
  getGlAccountsAsync,
  getCredentialsAsync,
  postCredentialsAsync,
  patchCredentialsAsync,
  deleteCredentialAsync,
  getPendingBatchesAsync,
  getPropertiesByIdAsync,
  getCredentialsUsersAsync,
  getPendingBatchesByIdAsync,
  getCredentialsPropertiesAsync,
  patchCredentialsPropertiesAsync,
  getGLAccountsAsync,
  getAppfolioPropertiesAsync,
  patchAppfolioPropertiesAsync,
  selectedItems: types.optional(types.array(types.string), []),
  glAccounts: types.optional(types.array(GLAccount), []),
  utilitiesGlSettings: types.optional(types.array(UtilityGlSettings), [])
}).actions(store => {
  return {
    resetUtilitiesGlSettings() {
      try {
        store.utilitiesGlSettings = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    batchSetUtilitiesGlSettings(data, list) {
      try {
        store.utilitiesGlSettings = cast([]);
        data.map(i => {
          const ci = list.find(u => u.id === i.propertyUtilityLivableId);
          store.utilitiesGlSettings.push({
            utilityId: ci !== null && ci !== void 0 && ci.utilityId ? ci.utilityId : '',
            propertyUtilityLivableId: i.propertyUtilityLivableId,
            glAccountExternalId: i.glAccountExternalId
          });
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setUtilitiesGlSettings(data) {
      try {
        const idx = store.utilitiesGlSettings.findIndex(i => i.utilityId === data.utilityId);
        if (idx !== -1) {
          store.utilitiesGlSettings[idx].glAccountExternalId = data.glAccountExternalId;
        } else {
          store.utilitiesGlSettings.push(data);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setGlAccounts(data) {
      try {
        store.glAccounts = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleSelectedItems(id) {
      try {
        if (!store.selectedItems.includes(id)) {
          store.selectedItems.push(id);
        } else {
          const idx = store.selectedItems.findIndex(i => i === id);
          store.selectedItems.splice(idx, 1);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleGlobalSelectedItems(data) {
      try {
        if (store.selectedItems.length > 0) {
          store.selectedItems = cast([]);
        } else {
          store.selectedItems = cast(data);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetSelectedItems() {
      try {
        store.selectedItems = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});
export const credentials = types.optional(CredentialsStore, {});

// store.credentials.getPropertiesByIdAsync.run()